import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-18 ant-col-xl-18" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Concluir", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: "50%",
    centered: "",
    maskClosable: false,
    "get-container": false,
    "wrap-class-name": "modal-desconto"
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, " Informe o Desconto do Produto: " + _toDisplayString(_ctx.props.item.itemNotaFiscal.descricao), 1)
      ])
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.concluirDesconto()))
        }, _hoisted_4)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_form_item, {
                label: "Valor Produto",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_campo_numerico, {
                    valor: _ctx.computedItem.itemNotaFiscal.precoUnitario,
                    "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedItem.itemNotaFiscal.precoUnitario) = $event)),
                    "quantidade-casas-decimais": 2,
                    monetario: true
                  }, null, 8, ["valor"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_a_form_item, {
                label: "Valor Desconto",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_campo_numerico, {
                    valor: _ctx.computedItem.itemNotaFiscal.valorDesconto,
                    "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedItem.itemNotaFiscal.valorDesconto) = $event)),
                    "quantidade-casas-decimais": 2,
                    monetario: true
                  }, null, 8, ["valor"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}